import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  darkmode: localStorage.getItem('darkmode')
    ? JSON.parse(localStorage.getItem('darkmode'))
    : false,
};

const darkmodeSlice = createSlice({
  name: 'darkmode',
  initialState,
  reducers: {
    setDarkmode: (state, action) => {
      state.darkmode = action.payload;
      localStorage.setItem('darkmode', JSON.stringify(action.payload));
    },
  },
});

export const {setDarkmode } = darkmodeSlice.actions;

export default darkmodeSlice.reducer;
